import React, { useEffect, useRef, useState } from "react";
import { FormTextInput } from "./FormTextInput";
import { ShowHide } from "components/layout";
import { FormHelperText } from "./FormHelperText";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./FormFields.css";

export function FormCodeInput({
    value = "",
    length = 0,
    onChange = () => { },
    isLoading = false,
    isDisabled = false,
    headingText = "",
    helperText = <></>,
    dangerHelperText = <></>
}) {
    const [boxes, setBoxes] = useState([]);
    const internalValue = useRef("");
    const inputRefs = useRef([]);

    useEffect(() => {
        if (!length || value === undefined) {
            return;
        }

        const valueArr = value.split("");

        let tempBoxes = [];
        for (let i = 0; i < length; i++) {
            tempBoxes.push(i < valueArr.length ? valueArr[i] : " ");
        }

        setBoxes(tempBoxes);
        internalValue.current = tempBoxes.join("");

    }, [length, value]);

    useEffect(function () {

        const onInputChange = function (newValue, index) {

            let clonedValue = internalValue.current;
            const updatedChar = newValue != null ? newValue.toUpperCase() : " ";

            clonedValue = clonedValue.substring(0, index) + updatedChar + clonedValue.substring(index + 1);

            onChange(clonedValue);
        }

        const handleNonAlphaInput = function (event) {

            const index = inputRefs.current.indexOf(event.target);
            let moveForward = false;
            let moveBackward = false;
            let reselect = false;

            if (event.key === "ArrowRight") {
                moveForward = true;
            } else if (event.key === "ArrowLeft") {
                moveBackward = true;
            } else if (event.key === "Backspace") {
                onInputChange(null, index);
                moveBackward = true;
            }
            else if (event.key === "Delete") {
                onInputChange(null, index);
                reselect = true;
            }

            if (moveForward && index < length - 1) {
                inputRefs.current[index + 1].focus();
            }

            if (moveBackward && index > 0) {
                inputRefs.current[index - 1].focus();
            }

            if (reselect || moveBackward && index === 0) {
                inputRefs.current[index].value = " "; // Clear the input if it's not valid
            }
        }

        const handleAlphaInput = function (event) {

            const index = inputRefs.current.indexOf(event.target);

            const inputText = event.data && event.data.length > 0 ? event.data[event.data.length - 1] : "";
            const validChars = /^[a-zA-Z0-9]$/;

            if (validChars.test(inputText)) {
                onInputChange(inputText, index);

                if (index < length - 1) {
                    inputRefs.current[index + 1].focus();
                }
            } else {
                inputRefs.current[index].value = " "; // Clear the input if it's not valid
            }
        }

        for (const element of inputRefs.current) {

            //Remove any existing event listeners to stop duplicates
            element.removeEventListener("keyup", handleNonAlphaInput);
            element.removeEventListener("input", handleAlphaInput);

            //re-add the event listeners
            element.addEventListener("keyup", handleNonAlphaInput);
            element.addEventListener("input", handleAlphaInput);


        }

    }, [inputRefs.current?.length])

    return (
        <div className="form-field">
            <ShowHide
                evaluator={headingText != null}
                show={
                    <h3 className={classNames({ "bp6-skeleton": isLoading })}>
                        {headingText}
                    </h3>
                }
            />
            <FormHelperText loading={isLoading}>{helperText}</FormHelperText>
            <div className="inline-items form-code-input">
                {boxes && boxes.map(function (boxValue, i) {
                    return (

                        <div className="code-input-box" key={`code-input-${i}`}>
                            <FormTextInput
                                id={`code-input-box-${i}`}
                                value={boxValue}
                                onChange={() => { }}
                                minLength={0}
                                maxLength={2}
                                loading={isLoading}
                                disabled={isDisabled}
                                inputRef={(el) => (inputRefs.current[i] = el)}
                            />
                        </div>

                    );
                })}
            </div>
            <FormHelperText loading={isLoading} danger={true}>{dangerHelperText}</FormHelperText>
        </div >
    );
}

FormCodeInput.propTypes = {
    value: PropTypes.string,
    length: PropTypes.number,
    onChange: PropTypes.func,
    isLoading: PropTypes.bool,
    isDisabled: PropTypes.bool,
    headingText: PropTypes.string,
    helperText: PropTypes.node,
    dangerHelperText: PropTypes.node,
};
